// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { brewcontrolNodeId } from './BrewcontrolNode';
import { z } from 'zod';
export const brewcontrolLogId = (z.string());
export const brewcontrolLog = z.object({
    id: brewcontrolLogId,
    node_id: brewcontrolNodeId,
    node_log_id: z.string(),
    logged_at: z.date(),
    level: z.string(),
    source: z.string(),
    message: z.string(),
    payload: z.unknown().nullable(),
    created_at: z.date(),
});
export const brewcontrolLogInitializer = z.object({
    id: brewcontrolLogId.optional(),
    node_id: brewcontrolNodeId,
    node_log_id: z.string(),
    logged_at: z.date(),
    level: z.string(),
    source: z.string(),
    message: z.string(),
    payload: z.unknown().optional().nullable(),
    created_at: z.date().optional(),
});
export const brewcontrolLogMutator = z.object({
    id: brewcontrolLogId.optional(),
    node_id: brewcontrolNodeId.optional(),
    node_log_id: z.string().optional(),
    logged_at: z.date().optional(),
    level: z.string().optional(),
    source: z.string().optional(),
    message: z.string().optional(),
    payload: z.unknown().optional().nullable(),
    created_at: z.date().optional(),
});
//# sourceMappingURL=BrewcontrolLog.js.map